export const SETTINGS_KEY = 'itinerary';
